import { ChapterHeading, Reveal } from "./Reveal";
import { IMAGES } from "../config/site";

const SPOTS = [
  { title: "Ala Moana Beach Park", body: "Among the project's makai-side surroundings — morning swims, sunset walks, and open green space." },
  { title: "Ala Moana Center", body: "350+ shops and restaurants at the largest open-air shopping center in the world, close by." },
  { title: "SALT at Our Kaka'ako", body: "Local dining, boutiques, and galleries just across the street." },
  { title: "Our Kaka'ako", body: "Honolulu's creative master-planned community — farmers markets and street art bring the neighborhood together." },
];

const Neighborhood = () => (
  <section className="py-24 md:py-32" data-testid="neighborhood-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <ChapterHeading number="05" overline="The Neighborhood" title="Where the city exhales into the ocean." />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mt-14 md:mt-20">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-px bg-line border border-line">
            {SPOTS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.1} className="bg-ivory">
                <div className="p-7 md:p-8" data-testid={`neighborhood-blurb-${i}`}>
                  <p className="font-serif text-lg md:text-xl font-light text-charcoal">{s.title}</p>
                  <p className="text-sm text-stone2 leading-relaxed mt-3">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal className="lg:col-span-7 order-1 lg:order-2" delay={0.15}>
          <div className="overflow-hidden aspect-[4/3] lg:aspect-auto lg:h-full group" data-testid="neighborhood-image-frame">
            <img
              src={IMAGES.wellnessWater}
              alt="Aerial view of ocean water meeting the sand — placeholder imagery"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              data-testid="neighborhood-image"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Neighborhood;

